/* @flow strict */

import * as React from 'react';
import _ from 'lodash';

import './styles.scss';

type PropsType = {
  name: string,
  id: string,
  label?: string | React.Node,
  style?: {},
  onChange?: (e) => void,
  onFocus?: (e) => void,
  onBlur?: (e) => void,
  value?: any,
  dataId?: string,
  readonly?: boolean,
  classes?: {
    input?: string
  },
  isShowLimit?: boolean,
  maxLength?: number,
  rows?: number
};

const SimpleTextarea = (props: PropsType): React.Element<'div'> => {
  const [isShowLimitLabel, toggleShowLimitLabel] = React.useState(false);
  const [isShowLimitWarning, toggleShowLimitWarning] = React.useState(false);
  const isShowValMsg = !props.value || props.value.toString().length < 1 || isShowLimitWarning;

  return (
    <>
      {props.label ? <label htmlFor={props.id}>{props.label}</label> : null}
        <>
          <textarea
            className={`
              ${_.get(props, 'classes.input', 'form-control')}
              ${isShowValMsg ? ' validationElement' : ' '}
              SimpleTextarea-${props.id}
            `}
            name={props.name}
            id={props.id}
            data-id={props.dataId}
            value={props.value ? props.value : ''}
            onChange={(e: any) => {
              if (props.isShowLimit) {
                toggleShowLimitWarning(_.size(e.target.value) > props.maxLength);
              }

              if (props.onChange) {
                props.onChange(e);
              }
            }}
            onFocus={(e: any) => {
              if (props.onFocus) {
                props.onFocus(e);
              }

              if (props.isShowLimit) {
                toggleShowLimitLabel(true);
              }
            }}
            onBlur={(e: any) => {
              if (props.onBlur) {
                props.onBlur(e);
              }

              if (props.isShowLimit) {
                toggleShowLimitLabel(false);
              }
            }}
            readOnly={props.readonly}
            rows={props.rows ? props.rows : 2}
          />

          {props.isShowLimit && isShowLimitLabel &&
            <span
              className='SimpleInput__limitPlaceholder SimpleInput__limitPlaceholder-addons'
            >
              {_.size(props.value)}/{props.maxLength}
            </span>
          }

          <div className='vMsg' style={{ display: isShowValMsg ? 'block' : 'none' }}>
              {isShowLimitWarning ?
                <>Please enter no more than {props.maxLength} characters.</>
                :
                <>This field is required.</>
              }
            </div>
        </>
    </>
  );
};

export default SimpleTextarea;
